import { createBrowserRouter, Navigate } from "react-router-dom";
import RootLayout from "../layout/root";
import Home from "../pages/home";
import Analytics from "../pages/analytics";
import ReportsSales from "../pages/reports-sales";
import ReportsLeads from "../pages/reports-leads";
import ReportsProject from "../pages/reports-project";
import AppsChat from "../pages/apps-chat";
import LayoutApplications from "../layout/layoutApplications";
import AppsEmail from "../pages/apps-email";
import ReportsTimesheets from "../pages/reports-timesheets";
import LoginCover from "../pages/login-cover";
import AppsTasks from "../pages/apps-tasks";
import AppsNotes from "../pages/apps-notes";
import AppsCalender from "../pages/apps-calender";
import AppsStorage from "../pages/apps-storage";
import Proposalist from "../pages/proposal-list";
import CustomersList from "../pages/customers-list";
import ProposalView from "../pages/proposal-view";
import ProposalEdit from "../pages/proposal-edit";
import LeadsList from "../pages/leadsList";
import MailTemplates from "../pages/mail-template";
import CustomersView from "../pages/customers-view";

import ProposalCreate from "../pages/proposal-create";

import LeadsCreate from "../pages/leads-create";
import PaymentList from "../pages/payment-list";
import PaymentView from "../pages/payment-view";
import PaymentCreate from "../pages/payment-create";
import ProjectsList from "../pages/projects-list";
import ProjectsView from "../pages/projects-view";
import ProjectsCreate from "../pages/projects-create";
import SettingsGaneral from "../pages/settings-ganeral";
import SettingInvoice from "../pages/setting-invoice";

import LayoutSetting from "../layout/layoutSetting";
import SettingsSeo from "../pages/settings-seo";
import SettingsApi from "../pages/settings-api";
import SettingIndex from "../pages/setting-index";
import SettingOneSignal from "../pages/setting-one-signal";
import SettingsTags from "../pages/settings-tags";
import SettingsEmail from "../pages/settings-email";
import SettingsCdn from "../pages/settings-cdn";
import SettingsSms from "../pages/settings-sms";
import SettingsTasks from "../pages/settings-tasks";
import SettingsLeads from "../pages/settings-leads";
import SettingsMiscellaneous from "../pages/settings-miscellaneous";
import SettingsRecaptcha from "../pages/settings-recaptcha";
import SettingsDomain from "../pages/setting-domain-form";

import SettingsCustomers from "../pages/settings-customers";
import SettingsGateways from "../pages/settings-gateways";
import SettingsFinance from "../pages/settings-finance";
import SettingsSite from "../pages/redirect-table";
import SettingsIp from "../pages/settings-ip";

import SettingsUzanti from "../pages/settings-uzanti";
import SettingsUzantiEdit from "../pages/settings-uzanti-edit";
import LayoutAuth from "../layout/layoutAuth";
import LoginMinimal from "../pages/login-minimal";
import LoginCreative from "../pages/login-creative";
import RegisterCover from "../pages/register-cover";
import RegisterMinimal from "../pages/register-minimal";
import RegisterCreative from "../pages/register-creative";
import ResetCover from "../pages/reset-cover";
import ResetMinimal from "../pages/reset-minimal";
import ResetCreative from "../pages/reset-creative";
import ErrorCover from "../pages/error-cover";
import ErrorCreative from "../pages/error-creative";
import ErrorMinimal from "../pages/error-minimal";
import OtpCover from "../pages/otp-cover";
import OtpMinimal from "../pages/otp-minimal";
import OtpCreative from "../pages/otp-creative";
import MaintenanceCover from "../pages/maintenance-cover";
import MaintenanceMinimal from "../pages/maintenance-minimal";
import MaintenanceCreative from "../pages/maintenance-creative";
import HelpKnowledgebase from "../pages/help-knowledgebase";
import WidgetsLists from "../pages/widgets-lists";
import WidgetsTables from "../pages/widgets-tables";
import WidgetsCharts from "../pages/widgets-charts";
import WidgetsStatistics from "../pages/widgets-statistics";
import WidgetsMiscellaneous from "../pages/widgets-miscellaneous";
import LeadsView from "../pages/leads-view";
import UpdateRole from "../pages/UpdateRole";
import RolesList from "../pages/RolesList";
import CreateRole from "../pages/CreateRole";
import AuthorizationTable from "../pages/authorization-table";
import ModuleCreate from "../pages/module-create";
import ModuleTable from "../pages/module-table";
import ModuleEdit from "../pages/module-edit";
import LeadsEdit from "../pages/leads-edit";
import LanguagesTable from "../pages/Language_Table";
import LanguagesCreateTable from "../pages/Language_Create";
import LanguagesEditTable from "../pages/Language_Edit";
import LanguagesViewTable from "../pages/Language_View";
import LanguagesTranslateTable from "../pages/Language_Translation_edit";
import CustomersCreate from "../pages/customer-create";
import MailEdit from "../pages/mail-template-edit";
import SettingsGoogleApi from "../pages/settingsGoogleApi";
import Website from "../pages/admin-website";
import DefinitionsTable from "../pages/definitions-table";
import MailCreate from "../pages/mail-template-create";
import MailView from "../pages/mail-template-view";
import DefinitionsEdit from "../pages/definitions-edit";
import RedirectEdit from "../pages/redirect-edit";
import SettingsIpEdit from "../pages/settings-ip-edit";
import ProtectedRoute from "../auth/ProtectedRoute";
import SalesProtectedRoute from "../auth/SalesProtectedRoute";
import ModuleTableCreate from "../pages/module-table-create";
import ModuleDataCreate from "../pages/module-data-create";
import ModuleDataEdit from "../pages/module-data-edit";
import CategoryTable from "../pages/category-table";
import CategoryEdit from "../pages/category-edit";
import CategoryCreate from "../pages/category-create";
import TestCategoryTable from "../pages/test-category-table";
import TestCategoryEdit from "../pages/test-category-edit";
import TestCategoryCreate from "../pages/test-category-create";
import SettingControl from "../pages/setting-control-form";
import SettingImageSize from "../pages/setting-image-size-form";
import VersionTable from "../pages/version-table";
import VersionEdit from "../pages/version-edit";
import VersionCreate from "../pages/version-create";
import VersionView from "../pages/version-view";
import TrashLeadsTable from "../pages/trash-leads-table";
import TrashModuleTableCreate from "../pages/trash-module-table-create";
import NavigationBarStatus from "../pages/navigation-bar-status";
import TrashMailTemplatesTable from "../pages/trash-mail-templates-table";
import TrashModuleTable from "../pages/trash-module-table";
import TrashRoleTable from "../pages/trash-role-table";
import TrashVersionTable from "../pages/trash-version-table";
import TrashCustomerTable from "../pages/trash-customer-table";
import SelectElements from "../pages/select-elements";
import FormReaderTable from "../pages/form-reader-table";
import FormReaderCreate from "../pages/form-reader-create";
import OrganisationTable from "../pages/institution-table";
import OrganisationCreate from "../pages/institution-create";
import InstitutionEdit from "../pages/institution-edit";
import InstitutionView from "../pages/institution-view";
import BilisselBeceriCreate from "../pages/bilissel-beceri-create";
import BilisselBeceriTable from "../pages/bilissel-beceri-table";
import BilisselBeceriView from "../pages/bilissel-beceri-view";
import BilisselBeceriEdit from "../pages/bilissel-beceri-edit";
import ClassesEdit from "../pages/classes-edit";
import ClassesView from "../pages/classes-view";
import ClassesCreate from "../pages/classes-create";
import ClassesTable from "../pages/classes-table";
import OpticalFormEdit from "../pages/quiz-edit";
import OpticalFormView from "../pages/optical-form-view";
import OpticalFormCreate from "../pages/quiz-create";
import OpticalFormTable from "../pages/quiz-table";
import OpticalFormQuestions from "../pages/quiz-questions";
import OpticalFormStudentAnswerTable from "../pages/optical-form-student-answer-table";
import StudentsTable from "../pages/students-table";
import StudentsEdit from "../pages/students-edit";
import EducationYearTable from "../pages/education-year-table";
import EducationYearCreate from "../pages/education-year-create";
import VersionPage from "../pages/version-page";
import TestScoreCommentsTable from "../pages/test-score-comments-table";
import TestScoreCommentsEdit from "../pages/test-score-comments-edit";
import TestScoreCommentsCreate from "../pages/test-score-comments-create";
import TestScoreCommentsView from "../pages/test-score-comments-view";
import StaticsTable from "../pages/statics-table";
import StaticsCreate from "../pages/statics-create";
import StaticsEdit from "../pages/statics-edit";
import TestDualResultEdit from "../pages/test-dual-result-edit";
import TestDualResultCreate from "../pages/test-dual-result-create";
import TestDualResultTable from "../pages/test-dual-result-table";
import TestTypeTable from "../pages/test-types-table";
import TestTypeCreate from "../pages/test-types-create";
import TestTypeEdit from "../pages/test-types-edit";

import TestDualResultView from "../pages/test-dual-result-view";
import TotalStaticsTable from "../pages/total-statistics-table";
import OrderTable from "../pages/order-table";
import OrderPaidTable from "../pages/order-paid-table";
import OrderShippedTable from "../pages/order-shipped-table";
import OrderCancelledTable from "../pages/order-cancelled-table";
import OrderDeliveredTable from "../pages/order-delivered-table";
import OrderView from "../pages/order-view";
import CouponTable from "../pages/coupon-table";
import CouponEdit from "../pages/coupon-edit";
import CouponCreate from "../pages/coupon-create";
import CouponView from "../pages/coupon-view";

import StockCategoryTable from "../pages/stock-category-table";
import StockCategoryCreate from "../pages/stock-category-create";
import StockCategoryView from "../pages/stock-category-view";
import StockCategoryEdit from "../pages/stock-category-edit";

import StockReportPage from "../pages/stock-report-page";

import StockBrandTable from "../pages/stock-brand-table";
import StockBrandCreate from "../pages/stock-brand-create";
import StockBrandView from "../pages/stock-brand-view";
import StockBrandEdit from "../pages/stock-brand-edit";

import StockFeatureTable from "../pages/stock-feature-table";
import StockFeatureCreate from "../pages/stock-feature-create";
import StockFeatureView from "../pages/stock-feature-view";
import StockFeatureEdit from "../pages/stock-feature-edit";

import WarehouseTable from "../pages/warehouse-table";
import WarehouseCreate from "../pages/warehouse-create";
import WarehouseView from "../pages/warehouse-view";
import WarehouseEdit from "../pages/warehouse-edit";

import ProductTable from "../pages/product-table";
import ProductCreate from "../pages/product-create";
import ProductView from "../pages/product-view";
import ProductEdit from "../pages/product-edit";

import CurrencyTable from "../pages/currency-table";
import CurrencyCreate from "../pages/currency-create";
import CurrencyView from "../pages/currency-view";
import CurrencyEdit from "../pages/currency-edit";
import ProductReviewTable from "../pages/product-review-table";
import ProductReviewView from "../pages/product-review-view";
import AdminFooterCompanyLogo from "../pages/admin-footer-logo-page";
import MessageTypeTable from "../pages/message-type-table";

import SettingKdvForm from "../pages/setting-kdv";
import OrderStatusPage from "../pages/order-status-page";
import OrderSettingsPage from "../pages/order-settings-page";
import CustomSwitchPage from "../pages/custom-switch-page";

import ManagementTable from "../pages/management-table";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <ProtectedRoute />, // 🔐 korumalı alan
      children: [
        {
          path: "/",
          element: <RootLayout />,
          children: [
            {
              path: "/",
              element: <Home />,
            },
            {
              path: "/dashboards/analytics",
              element: <Analytics />,
            },
            {
              path: "/admin/footer/logo",
              element: <AdminFooterCompanyLogo />,
            },
            {
              path: "/reports/sales",
              element: <ReportsSales />,
            },
            {
              path: "/reports/leads",
              element: <ReportsLeads />,
            },
            {
              path: "/reports/project",
              element: <ReportsProject />,
            },
            {
              path: "/reports/timesheets",
              element: <ReportsTimesheets />,
            },
            {
              path: "/proposal/list",
              element: <Proposalist />,
            },
            {
              path: "/proposal/view",
              element: <ProposalView />,
            },
            {
              path: "/proposal/edit",
              element: <ProposalEdit />,
            },
            {
              path: "/proposal/create",
              element: <ProposalCreate />,
            },
            {
              path: "/comment/table",
              element: <ProductReviewTable />,
            },
            {
              path: "/comment/view/:id",
              element: <ProductReviewView />,
            },
            {
              path: "/payment/list",
              element: <PaymentList />,
            },
            {
              path: "/payment/view",
              element: <PaymentView />,
            },
            {
              path: "/payment/create",
              element: <PaymentCreate />,
            },
            {
              path: "/customers/list",
              element: <CustomersList />,
            },
            {
              path: "/customers/trash",
              element: <TrashCustomerTable />,
            },
            {
              path: "/customers/view/:id",
              element: <CustomersView />,
            },
            {
              path: "/customers/create",
              element: <CustomersCreate />,
            },
            {
              path: "/leads/list",
              element: <LeadsList />,
            },
            {
              path: "/leads/trash",
              element: <TrashLeadsTable />,
            },
            {
              path: "/modules/:slug/trash",
              element: <TrashModuleTableCreate />,
            },
            {
              path: "/admin/modules/trash",
              element: <TrashModuleTable />,
            },
            {
              path: "/admin/roles",
              element: <RolesList />,
            },
            {
              path: "/message/template",
              element: <MessageTypeTable />,
            },
            {
              path: "/admin/roles/trash",
              element: <TrashRoleTable />,
            },
            {
              path: "/admin/language",
              element: <LanguagesTable />,
            },
            {
              path: "/admin/website",
              element: <Website />,
            },
            {
              path: "/admin/language/create",
              element: <LanguagesCreateTable />,
            },
            {
              path: "/admin/language/edit/:id",
              element: <LanguagesEditTable />,
            },
            {
              path: "/admin/language/translation/:id",
              element: <LanguagesTranslateTable />,
            },
            {
              path: "/admin/language/view/:id",
              element: <LanguagesViewTable />,
            },
            {
              path: "/admin/roles/edit/:id",
              element: <UpdateRole />,
            },
            {
              path: "/admin/roles/create",
              element: <CreateRole />,
            },
            {
              path: "/order/table",
              element: <OrderTable />,
            },
            {
              path: "/order/settings",
              element: <OrderSettingsPage />,
            },
            {
              path: "/order/status-table",
              element: <OrderStatusPage />,
            },
            {
              path: "/order/paid-table",
              element: <OrderPaidTable />,
            },
            {
              path: "/order/shipped-table",
              element: <OrderShippedTable />,
            },
            {
              path: "/order/delivered-table",
              element: <OrderDeliveredTable />,
            },
            {
              path: "/order/cancelled-table",
              element: <OrderCancelledTable />,
            },
            {
              path: "/order/view/:id",
              element: <OrderView />,
            },
            {
              path: "/custom-switch-page",
              element: <CustomSwitchPage />,
            },
            {
              path: "/management-table",
              element: <ManagementTable />,
            },
            {
              path: "/coupon/table",
              element: <CouponTable />,
            },
            {
              path: "/coupon/edit/:id",
              element: <CouponEdit />,
            },
            {
              path: "/coupon/create",
              element: <CouponCreate />,
            },
            {
              path: "/coupon/view/:id",
              element: <CouponView />,
            },

            {
              path: "/leads/create",
              element: <LeadsCreate />,
            },
            {
              path: "/version/create",
              element: <VersionCreate />,
            },
            {
              path: "/version/list",
              element: <VersionTable />,
            },
            {
              path: "/version/trash",
              element: <TrashVersionTable />,
            },
            {
              path: "/version/edit/:id",
              element: <VersionEdit />,
            },
            {
              path: "/version/view/:id",
              element: <VersionView />,
            },
            {
              path: "/test/score/:testId/view/:id",
              element: <TestScoreCommentsView />,
            },
            {
              path: "/test/score/:testId/edit/:id",
              element: <TestScoreCommentsEdit />,
            },
            {
              path: "/test/score/:testId/category/:categoryId/edit/:id",
              element: <TestScoreCommentsEdit />,
            },
            {
              path: "/test/score/:testId/create",
              element: <TestScoreCommentsCreate />,
            },
            {
              path: "/test/:testId/category/:categoryId/score/create",
              element: <TestScoreCommentsCreate />,
            },

            {
              path: "/test/score/table/:testId",
              element: <TestScoreCommentsTable />,
            },
            {
              path: "/test/:testId/category/:categoryId/score/table",
              element: <TestScoreCommentsTable />,
            },
            {
              path: "/test/dual-results/:testId",
              element: <TestDualResultTable />,
            },
            {
              path: "/test/dual-results/create/:testId",
              element: <TestDualResultCreate />,
            },
            {
              path: "/test/dual-results/edit/:testId/:id",
              element: <TestDualResultEdit />,
            },
            {
              path: "/test/dual-results/view/:testId/:id",
              element: <TestDualResultView />,
            },
            {
              path: "/test/:id/category/create",
              element: <TestCategoryCreate />,
            },
            {
              path: "/test/:id/category/edit/:categoryId",
              element: <TestCategoryEdit />,
            },
            {
              path: "/test/:id/category/list",
              element: <TestCategoryTable />,
            },
            {
              path: "/version/history",
              element: <VersionPage />,
            },
            {
              path: "/leads/view/:id",
              element: <LeadsView />,
            },
            {
              path: "/leads/mail",
              element: <MailTemplates />,
            },
            {
              path: "/mail-templates/edit/:id",
              element: <MailEdit />,
            },
            {
              path: "/mail-templates/create",
              element: <MailCreate />,
            },
            {
              path: "/mail-templates/trash",
              element: <TrashMailTemplatesTable />,
            },
            {
              path: "/mail-templates/view/:id",
              element: <MailView />,
            },
            {
              path: "/settings/site",
              element: <SettingsSite />,
            },

            {
              path: "/settings/definition",
              element: <DefinitionsTable />,
            },
            {
              path: "/definition/edit/:id",
              element: <DefinitionsEdit />,
            },
            {
              path: "/redirect/edit/:id",
              element: <RedirectEdit />,
            },
            {
              path: "/admin/modules",
              element: <AuthorizationTable />,
            },
            {
              path: "/form/reader/table",
              element: <FormReaderTable />,
            },
            {
              path: "/form/reader/create",
              element: <FormReaderCreate />,
            },
            {
              path: "/institutions/create",
              element: <OrganisationCreate />,
            },
            {
              path: "/institutions/edit/:id",
              element: <InstitutionEdit />,
            },
            {
              path: "/institutions/view/:id",
              element: <InstitutionView />,
            },
            {
              path: "/skills/create",
              element: <BilisselBeceriCreate />,
            },
            {
              path: "/skills/table",
              element: <BilisselBeceriTable />,
            },
            {
              path: "/skills/edit/:id",
              element: <BilisselBeceriEdit />,
            },
            {
              path: "/skills/view/:id",
              element: <BilisselBeceriView />,
            },
            {
              path: "/institutions/table",
              element: <OrganisationTable />,
            },

            {
              path: "/classes/table",
              element: <ClassesTable />,
            },

            {
              path: "/classes/create",
              element: <ClassesCreate />,
            },

            {
              path: "/categories/table",
              element: <StockCategoryTable />,
            },
            {
              path: "/report/table",
              element: <StockReportPage />,
            },

            {
              path: "/categories/create",
              element: <StockCategoryCreate />,
            },
            {
              path: "/categories/edit/:id",
              element: <StockCategoryEdit />,
            },

            {
              path: "/categories/view/:id",
              element: <StockCategoryView />,
            },

            {
              path: "/brands/table",
              element: <StockBrandTable />,
            },

            {
              path: "/brands/create",
              element: <StockBrandCreate />,
            },
            {
              path: "/brands/edit/:id",
              element: <StockBrandEdit />,
            },

            {
              path: "/brands/view/:id",
              element: <StockBrandView />,
            },

            {
              path: "/features/table",
              element: <StockFeatureTable />,
            },

            {
              path: "/features/create",
              element: <StockFeatureCreate />,
            },
            {
              path: "/features/edit/:id",
              element: <StockFeatureEdit />,
            },

            {
              path: "/features/view/:id",
              element: <StockFeatureView />,
            },

            //para birimi
            {
              path: "/currency/table",
              element: <CurrencyTable />,
            },

            {
              path: "/currency/create",
              element: <CurrencyCreate />,
            },
            {
              path: "/currency/edit/:id",
              element: <CurrencyEdit />,
            },

            {
              path: "/currency/view/:id",
              element: <CurrencyView />,
            },

            {
              path: "/warehouses/table",
              element: <WarehouseTable />,
            },

            {
              path: "/warehouses/create",
              element: <WarehouseCreate />,
            },
            {
              path: "/warehouses/edit/:id",
              element: <WarehouseEdit />,
            },

            {
              path: "/warehouses/view/:id",
              element: <WarehouseView />,
            },

            {
              path: "/products/table",
              element: <ProductTable />,
            },

            {
              path: "/products/create",
              element: <ProductCreate />,
            },
            {
              path: "/products/edit/:id",
              element: <ProductEdit />,
            },

            {
              path: "/products/view/:id",
              element: <ProductView />,
            },

            {
              path: "/test-types/edit/:id",
              element: <TestTypeEdit />,
            },

            {
              path: "/test-types/table",
              element: <TestTypeTable />,
            },

            {
              path: "/test-types/create",
              element: <TestTypeCreate />,
            },
            {
              path: "/test-types/edit/:id",
              element: <ClassesEdit />,
            },

            {
              path: "/classes/view/:id",
              element: <ClassesView />,
            },

            {
              path: "/education-year/table",
              element: <EducationYearTable />,
            },
            {
              path: "/education-year/create",
              element: <EducationYearCreate />,
            },

            {
              path: "/test/table",
              element: <OpticalFormTable />,
            },
            {
              path: "/stat/table",
              element: <StaticsTable />,
            },
            {
              path: "/total-stat/table",
              element: <TotalStaticsTable />,
            },
            {
              path: "/stat/create",
              element: <StaticsCreate />,
            },
            {
              path: "/stat/edit/:id",
              element: <StaticsEdit />,
            },
            {
              path: "/test/create",
              element: <OpticalFormCreate />,
            },
            {
              path: "/optical-form/students",
              element: <StudentsTable />,
            },
            {
              path: "/optical-form/students/edit/:id",
              element: <StudentsEdit />,
            },
            {
              path: "/optical-form/students/answer/:id",
              element: <OpticalFormStudentAnswerTable />,
            },
            {
              path: "/test/edit/:id",
              element: <OpticalFormEdit />,
            },
            {
              path: "/test/questions/:id",
              element: <OpticalFormQuestions />,
            },
            {
              path: "/test/view/:id",
              element: <OpticalFormView />,
            },

            {
              path: "/admin/modules/create",
              element: <ModuleCreate />,
            },
            {
              path: "/admin/navigation/status",
              element: <NavigationBarStatus />,
            },
            {
              path: "/modules/:slug/edit/:id",
              element: <ModuleDataEdit />,
            },
            {
              path: "/modules/:slug",
              element: <ModuleTableCreate />,
            },
            {
              path: "/modules/:slug/create",
              element: <ModuleDataCreate />,
            },
            {
              path: "/modules/:slug/category/create",
              element: <CategoryCreate />,
            },
            {
              path: "/modules/:slug/category/edit/:id",
              element: <CategoryEdit />,
            },
            {
              path: "/modules/:slug/category/list",
              element: <CategoryTable />,
            },
            {
              path: "/admin/modules/list",
              element: <ModuleTable />,
            },
            {
              path: "/admin/modules/edit/:slug",
              element: <ModuleEdit />,
            },
            {
              path: "/admin/modules/edit/:slug/select/:name",
              element: <SelectElements />,
            },
            {
              path: "/profile/edit/:id",
              element: <LeadsEdit />,
            },
            {
              path: "/projects/list",
              element: <ProjectsList />,
            },
            {
              path: "/projects/view",
              element: <ProjectsView />,
            },
            {
              path: "/projects/create",
              element: <ProjectsCreate />,
            },
            {
              path: "/widgets/lists",
              element: <WidgetsLists />,
            },
            {
              path: "/widgets/tables",
              element: <WidgetsTables />,
            },
            {
              path: "/widgets/charts",
              element: <WidgetsCharts />,
            },
            {
              path: "/widgets/statistics",
              element: <WidgetsStatistics />,
            },
            {
              path: "/widgets/miscellaneous",
              element: <WidgetsMiscellaneous />,
            },
            {
              path: "/help/knowledgebase",
              element: <HelpKnowledgebase />,
            },
          ],
        },
        {
          path: "/",
          element: <LayoutApplications />,
          children: [
            {
              path: "/applications/chat",
              element: <AppsChat />,
            },
            {
              path: "/applications/email",
              element: <AppsEmail />,
            },
            {
              path: "/applications/tasks",
              element: <AppsTasks />,
            },
            {
              path: "/applications/notes",
              element: <AppsNotes />,
            },
            {
              path: "/applications/calender",
              element: <AppsCalender />,
            },
            {
              path: "/applications/storage",
              element: <AppsStorage />,
            },
          ],
        },
        {
          path: "/",
          element: <LayoutSetting />,
          children: [
            {
              path: "/settings/ganeral",
              element: <SettingsGaneral />,
            },
            {
              path: "/settings/seo",
              element: <SettingsSeo />,
            },
            {
              path: "/settings/tags",
              element: <SettingsTags />,
            },
            {
              path: "/settings/invoice",
              element: <SettingInvoice />,
            },
            {
              path: "/settings/kdv",
              element: <SettingKdvForm />,
            },
            {
              path: "/settings/email",
              element: <SettingsEmail />,
            },
            {
              path: "/settings/cdn",
              element: <SettingsCdn />,
            },
            {
              path: "/settings/sms",
              element: <SettingsSms />,
            },
            {
              path: "/settings/api",
              element: <SettingsApi />,
            },
            {
              path: "/settings/control",
              element: <SettingControl />,
            },
            {
              path: "/settings/image",
              element: <SettingImageSize />,
            },

            {
              path: "/settings/tasks",
              element: <SettingsTasks />,
            },
            {
              path: "/settings/ip",
              element: <SettingsIp />,
            },
            {
              path: "/settings/ip/edit/:id",
              element: <SettingsIpEdit />,
            },
            {
              path: "/settings/tasks",
              element: <SettingsTasks />,
            },
            {
              path: "/settings/leads",
              element: <SettingsLeads />,
            },
            {
              path: "/settings/Support",
              element: <SettingsUzanti />,
            },
            {
              path: "/settings/fileType/edit/:id",
              element: <SettingsUzantiEdit />,
            },

            {
              path: "/settings/finance",
              element: <SettingsFinance />,
            },
            {
              path: "/settings/gateways",
              element: <SettingsGateways />,
            },
            {
              path: "/settings/customers",
              element: <SettingsCustomers />,
            },
            {
              path: "/settings/localization",
              element: <SettingsGoogleApi />,
            },
            {
              path: "/settings/index",
              element: <SettingIndex />,
            },
            {
              path: "/settings/onesignal",
              element: <SettingOneSignal />,
            },
            {
              path: "/settings/domain",
              element: <SettingsDomain />,
            },
            {
              path: "/settings/recaptcha",
              element: <SettingsRecaptcha />,
            },
            {
              path: "/settings/miscellaneous",
              element: <SettingsMiscellaneous />,
            },
          ],
        },
      ],
    },

    {
      path: "/",
      element: <LayoutAuth />,
      children: [
        {
          path: "/authentication/login/cover",
          element: <LoginCover />,
        },
        {
          path: "/authentication/login/minimal",
          element: <LoginMinimal />,
        },
        {
          path: "/authentication/login/creative",
          element: <LoginCreative />,
        },
        {
          path: "/authentication/register/cover",
          element: <RegisterCover />,
        },
        {
          path: "/authentication/register/minimal",
          element: <RegisterMinimal />,
        },
        {
          path: "/authentication/register/creative",
          element: <RegisterCreative />,
        },
        {
          path: "/authentication/reset/cover",
          element: <ResetCover />,
        },
        {
          path: "/authentication/reset/minimal",
          element: <ResetMinimal />,
        },
        {
          path: "/authentication/reset/creative",
          element: <ResetCreative />,
        },
        {
          path: "/authentication/404/cover",
          element: <ErrorCover />,
        },
        {
          path: "/authentication/404/minimal",
          element: <ErrorMinimal />,
        },
        {
          path: "/authentication/404/creative",
          element: <ErrorCreative />,
        },
        {
          path: "/authentication/verify/cover",
          element: <OtpCover />,
        },
        {
          path: "/authentication/verify/minimal",
          element: <OtpMinimal />,
        },
        {
          path: "/authentication/verify/creative",
          element: <OtpCreative />,
        },
        {
          path: "/authentication/maintenance/cover",
          element: <MaintenanceCover />,
        },
        {
          path: "/authentication/maintenance/minimal",
          element: <MaintenanceMinimal />,
        },
        {
          path: "/authentication/maintenance/creative",
          element: <MaintenanceCreative />,
        },
      ],
    },
  ],
  {
    basename: "/ctrl",
  },
);
